<div class="tw-flex tw-items-start tw-gap-3">
  <img
    src="images/icons/brackets-vault/tick-circle.svg"
    alt=""
    class="bv-get-started-tick tw-mt-0.5 tw-h-[19px] tw-w-[19px] tw-shrink-0 tw-object-contain"
    [class.bv-get-started-tick--completed]="completed()"
    [class.bv-get-started-tick--active]="isActive()"
    aria-hidden="true"
  />

  <div class="tw-min-w-0 tw-flex-1">
    <div
      class="tw-text-sm tw-leading-5"
      [class.tw-font-medium]="isActive()"
      [class.bv-get-started-task__title--active]="isActive()"
      [class.bv-get-started-task__title--completed]="completed() && !isActive()"
      [class.bv-get-started-task__title--pending]="!completed() && !isActive()"
    >
      {{ title() }}
    </div>

    @if (shouldShowSubtitle() || !completed()) {
      <div class="bv-get-started-task__subtitle tw-mt-1 tw-text-sm tw-leading-5">
        @if (subtitle()) {
          {{ subtitle() }}
        }
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
